export default function () {
  const widgetName = 'footerLogos';
  const widgetOpts = footerLogosOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.card-content').remove();
        $(this).removeAttr('target');
        $(this).attr('aria-label', data.items[x].ImageAlternateText);
      })
      
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}